import { api } from "@/lib/api";

export type AdminUser = {
  id: string;
  name: string;
  email: string;
  emailVerified: boolean;
  createdAt: string;
  isAdmin: boolean;
  hasPassword: boolean;
};

export const adminUsersApi = {
  list: () => api.get<AdminUser[]>("/admin/users"),
  update: (id: string, input: { name?: string; email?: string }) =>
    api.patch<{ ok: true }>(`/admin/users/${id}`, input),
  resetPassword: (id: string, newPassword: string) =>
    api.post<{ ok: true }>(`/admin/users/${id}/reset-password`, { newPassword }),
  remove: (id: string) => api.delete<{ ok: true }>(`/admin/users/${id}`),
};
